import React from 'react';
import snow from '../../../assets/svg/snow.svg';
import sun from '../../../assets/svg/sun.svg';
import Button from '../../../components/Buttons/Button';
import ButtonSec from '../../../components/Buttons/ButtonSecundary';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { useNavigate } from 'react-router';

const Intro: React.FC = () => {
  const { isTablet } = useScreenSize();
  const navigate = useNavigate();

  return (
    <section className="slide flex-colomn gap-2 relative">
      {/* <Tooltip /> */}
      <div className={`flex-colomn `}>
        <h1>
          <span className="tertiary-color ">More </span>then just cooling!
        </h1>
        <p className="slide-text">
          Met professionele <span className="bold">airco-installaties</span> zorgen wij voor
          <span className="bold"> comfortabel, gezond en energiezuinig binnenklimaat</span> —
          helemaal afgestemd op uw ruimte.
        </p>
      </div>

      <div className={`${isTablet ? 'flex-colomn' : 'flex-row'} space-between w-100 gap-2`}>
        <div className="flex-row">
          <img className="icon" src={snow} alt="phone icon" />
          <img className="icon" src={sun} alt="whatsapp icon" />
        </div>
        <div className={`${isTablet ? 'flex-colomn' : 'flex-row'}`}>
          <ButtonSec to="/installatie-voorbeelden" text="Bekijk voorbeelden" />
          <Button onClick={() => navigate('/', { state: { slide: 5 } })} text="Vraag offerte aan" />
        </div>
      </div>
    </section>
  );
};

export default Intro;
